<div style="background-image:url('assets/login.png');background-size:cover;background-position:center;position:fixed;height:100%;width:100%;margin-top:-10px;overflow:auto;"></div>
<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;position:relative;z-index:2;font-family:'Roboto', sans-serif;">

  @if (authenticatedUser) {
    <div class="authenticated-user mdc-card mdc-card--outlined">
      <form (ngSubmit)="continueAsAuthenticatedUser()" class="form-container">
        <div style="display:flex;flex-direction:column;align-items:flex-start;width:100%;">
          <div>You are currently logged in as:</div>
          <div style="display:flex;flex-direction:row;justify-content:flex-start;align-items:center;margin-top:16px;">
            <i class="material-icons" aria-hidden="true" style="font-size:38px;color:#1976d2;">account_circle</i>
            <div style="text-align:left;margin-left:8px;">
              <div><b>{{authenticatedUser.name}}</b></div>
              <small>{{authenticatedUser.customerName}}</small>
            </div>
          </div>
          <div style="font-size:14px;margin-top:16px;">
            Your existing session will expire on:
          </div>
          <div style="font-size:14px;margin-top:8px;"><b>{{authenticatedUser.expirationDateTime | date:'short'}}</b></div>
          <div style="margin-top:16px;padding-top:16px; text-align:left;font-size:14px;border-top:solid 2px #f1f1f1;">
            To continue click the button below or <a (click)="changeUsers()" style="cursor:pointer;">log out to change users.</a>
          </div>
        </div>
        <button type="submit" class="mdc-button mdc-button--raised" style="margin-top:20px;">
          <div class="mdc-button__ripple"></div>
          <span class="mdc-button__label clip">Continue as {{authenticatedUser.name}}</span>
        </button>
      </form>
    </div>
  }

  @if (!authenticatedUser) {
    <div class="mdc-card mdc-card--outlined" style="margin-top:50px;">
      <form (ngSubmit)="authenticate()" class="form-container">
        <div style="display:flex;flex-direction:row;justify-content:flex-start;align-items:center;margin-bottom:16px;width:100%;font-family:'Roboto',sans-serif;">
          <i class="material-icons" aria-hidden="true" style="font-size:46px;color:#1976d2;">lock</i>
          <div style="text-align:left;margin-left:8px;">
            <div style="font-size:24px;color:#1976d2;"><b>Authentication</b></div>
            <small>Enter Your User Credentials</small>
          </div>
        </div>
        <!--loginid-->
        <label class="mdc-text-field mdc-text-field--outlined">
          <input [(ngModel)]="credentials.loginId" name="loginId" type="text" class="mdc-text-field__input" aria-labelledby="loginId"/>
          <span class="mdc-notched-outline">
            <span class="mdc-notched-outline__leading"></span>
            <span class="mdc-notched-outline__notch">
              <span class="mdc-floating-label" id="loginId">Login Id</span>
            </span>
            <span class="mdc-notched-outline__trailing"></span>
          </span>
        </label>
        <!--password-->
        <label class="mdc-text-field mdc-text-field--outlined">
          <input [(ngModel)]="credentials.password" name="password" type="password" class="mdc-text-field__input" aria-labelledby="password"/>
          <span class="mdc-notched-outline">
            <span class="mdc-notched-outline__leading"></span>
            <span class="mdc-notched-outline__notch">
              <span class="mdc-floating-label" id="password">Password</span>
            </span>
            <span class="mdc-notched-outline__trailing"></span>
          </span>
        </label>
        <button type="submit" class="mdc-button mdc-button--raised">
          <div class="mdc-button__ripple"></div>
          <span class="mdc-button__label">Log In</span>
        </button>
      </form>
    </div>
  }
</div>